document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var burger = document.getElementById('navBurger');
  var links = document.getElementById('navLinks');
  if (burger && links) {
    burger.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product page thumbnail swap
  var main = document.getElementById('ProductMainImage');
  document.querySelectorAll('.thumb-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main && btn.dataset.full) main.src = btn.dataset.full;
    });
  });

});
